<div class='card-skeleton d-none d-sm-block'>
  <img src='cards-ui/assets/skeleton.svg' alt='Card is loading' />
</div>
<div class='card-skeleton d-block d-sm-none'>
  <img src='cards-ui/assets/skeleton-mobile.svg' alt='Card is loading' />
</div>
